import Icon from '../../../components/ui/AppIcon';
import './TrustBar.css'
import Common_title from './common_components/Common_title/Common_title';

const TrustBar = () => {
  const trustBadges = [
    {
      icon: 'CheckBadgeIcon',
      label: '1 Lakh +',
      description: 'Alumni Base',
     color: 'text-white',
      bgColor: 'bg-success/10',
    },
    {
      icon: 'StarIcon',
      label: '4.7 / 5',
      description: 'Student Rating',
      color: 'text-white',
      bgColor: 'bg-warning/10',
    },
    {
      icon: 'BuildingLibraryIcon',
      label: 'D.Y. Patil Group',
      description: '40+ Years Legacy',
      color: 'text-white',
      bgColor: 'bg-primary/10',
    },
    {
      icon: 'ShieldCheckIcon',
      label: 'Industry Recognized',
      description: 'Top Corporate Partners',
   color: 'text-white',
      bgColor: 'bg-secondary/10',
    },
  ];


   const trustBadges2 = [
    {
      icon: 'CheckBadgeIcon',
      label: 'UGC Approved',
      description: 'Government Recognized',
      color: 'text-success',
      bgColor: 'bg-success/10',
      img:"/assets/images/home/rank/ugc.png"
    },
    {
      icon: 'StarIcon',
      label: 'NAAC A++',
      description: 'Highest Accreditation',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      img:"/assets/images/home/rank/naac2.png"
    },
    {
      icon: 'BuildingLibraryIcon',
      label: 'AICTE Approved',
      description: 'Government Recognized',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      img:"/assets/images/home/rank/aicte.png"
    },
    {
      icon: 'ShieldCheckIcon',
      label: 'WES',
      description: 'Accredited in CAN',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      img:"/assets/images/home/rank/wes.webp"

    },
    
  ];


  return (
    <section className="bg-muted border-y border-border py-8 TrustBar">

      <Common_title className="text-center" title="University Accreditation"  />

      <div className="max-w-content mx-auto px-section-margin mb-3">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {trustBadges2.map((badge, index) => (
            <div key={index} className="flex flex-col items-center space-x-4 rounded-lg p-4 ">
              <div className='trust_img_holder '>
                <img src={badge?.img} className='trust_img'/>
              </div>
              {/* <div className={`flex-shrink-0 w-12 h-12 ${badge.bgColor} rounded-lg flex items-center justify-center`}>
                <Icon name={badge.icon as any} size={24} className={badge.color} variant="solid" />
              </div> */}
              <div className='text_holder_div'>
                <div className="font-bold text-text-primary text-sm text-center label_text">{badge.label}</div>
                <div className="text-xs text-text-secondary truncate text-center value_text">{badge.description}</div>
              </div>
            </div>
          ))}
        </div>

    </div>



      <div className="max-w-content mx-auto px-section-margin">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 cards_holder">
          {trustBadges.map((badge, index) => (
            <div key={index} className="flex items-center space-x-4 bg-background rounded-lg p-4 shadow-form card_div">
              <div className={`flex-shrink-0 w-12 h-12 ${badge.bgColor} rounded-lg flex items-center justify-center`}>
                <Icon name={badge.icon as any} size={24} className={badge.color} variant="solid" />
              </div>
              <div className="">
                <div className="font-bold text-text-primary text-sm label_text2">{badge.label}</div>
                <div className="text-xs text-text-secondary truncate value_text2">{badge.description}</div>
              </div>
            </div>
          ))}
        </div>

         <div className="online-mba-section">
      <div className="content-wrapper">
        <h3 className="online-mba-title">
          {/* <span className="highlight-primary">#1 </span> */}
          <span className="highlight-secondary">India's No. 1 Online MBA Program</span>
        </h3>
      </div>
      <div className="decorative-bar"></div>
    </div>
      </div>
    </section>
  );
};

export default TrustBar;